(function ($) {
    'use strict';

    $(function () {
        var link = $('a.link');
        link.on('click', function (e) {
            e.preventDefault();
            $(this).next().slideToggle();
            $('.works .content').not($(this).next()).slideUp();
            $(this).children('.cross').toggleClass('cross--active');

        })
    });
})(jQuery);
